import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class SidebarMenu extends Component {

  configure() {
    return super.configure();
  }

  initialize() {

    this.groups = $('.sidebar .menu ul li.has-items > a');

    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    this.groups.on('click', (event) => {
      return this.onClick(event);
    });
  }

  onClick(event) {

    let groupLink = $(event.currentTarget),
        menuGroup = groupLink.parent();

    menuGroup.toggleClass('is-active');

    event.preventDefault();
  }

}